import React, { FunctionComponent } from "react";
import Box from "@material-ui/core/Box";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

interface Props {
  id?: string;
  onNext: () => void;
  disabled?: boolean;
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      justifyContent: "flex-end",
      width: "100%",
      [theme.breakpoints.down("lg")]: {
        paddingBottom: "19px",
        paddingLeft: "29px",
        paddingRight: "29px",
      },
      [theme.breakpoints.up("xl")]: {
        paddingBottom: "26px",
        paddingLeft: "39px",
        paddingRight: "39px",
      },
    },
    nextButton: {
      paddingLeft: 0,
      paddingRight: 0,
      color: "#ffffff",
      background: "#92B4A7",
      [theme.breakpoints.down("lg")]: {
        width: "87px",
        minWidth: "87px",
        height: "33px",
      },
      [theme.breakpoints.up("xl")]: {
        width: "116px",
        minWidth: "116px",
        height: "45px",
      },
      "& .MuiButton-label": {
        [theme.breakpoints.down("lg")]: {
          fontSize: "12px",
        },
        [theme.breakpoints.up("xl")]: {
          fontSize: "16px",
        },
      },
      "&:hover": {
        background: "#92B4A7",
      }

    },
  })
);

export const ActionSection: FunctionComponent<Props> = (props) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Button
        id={props.id}
        variant="contained"
        onClick={props.onNext}
        className={classes.nextButton}
        disableFocusRipple={true}
        disableElevation={true}
        disableRipple={true}
        disabled={props.disabled}
      >
        Next
      </Button>
    </Box>
  );
};

export default ActionSection;
